export default __webpack_public_path__ + "2ab565b98b885d5f3b74e8cc5d57b3ed.png";